import styled from "styled-components";

export const ModalBtns = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  button {
    height: 56px;
    width: 202px;
  }
  button:nth-child(2) {
    background: linear-gradient(45deg, #0486f6, #53c6fd);
  }
`;
